module.exports = __webpack_public_path__ + "static/img/1.e8edf0e.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/school/1.png
// module id = cktn
// module chunks = 1